// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3qQok","modalFooterButton":"ModalNotes_modalFooterButton__3UFae"};